import { render, staticRenderFns } from "./FeAstra.vue?vue&type=template&id=58682038&"
import script from "./FeAstra.vue?vue&type=script&lang=js&"
export * from "./FeAstra.vue?vue&type=script&lang=js&"
import style0 from "./FeAstra.vue?vue&type=style&index=0&id=58682038&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports